import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import * as Sentry from '@sentry/react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { Crisp } from 'crisp-sdk-web'; //https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/npm/
// import { Crisp } from 'crisp-sdk-web'; //https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/npm/
import { ufSaloniBannerPayments } from 'utils/salonToken';
import LogRocket from 'logrocket';
import { isLightClient } from 'utils/lowMemory';
import { lockWebViewTextZoom } from 'utils/lockWebViewTextZoom';

lockWebViewTextZoom();

const lightClient = isLightClient();

if (!lightClient) {
  LogRocket.init('zb2/zb3');
}

const sentryIntegrations = [new Sentry.BrowserTracing()];
if (!lightClient) {
  sentryIntegrations.push(new Sentry.Replay());
}

Sentry.init({
  dsn: 'https://ac80f02284a64d729dc9497fdd61cc49@o446823.ingest.sentry.io/4505249567408128',
  integrations: sentryIntegrations,
  tracesSampleRate: lightClient ? 0 : 0.1,
  enabled: true,
  environment: process.env.NODE_ENV,
  release: process.env.REACT_APP_VERSION,
  enableTracing: !lightClient,
  beforeSend: async function (event, hint) {
    const salonInformation = localStorage.getItem('salons');
    let salon = null;
    try {
      salon = JSON.parse(salonInformation);
    } catch {
      salon = salonInformation;
    }
    event.extra.salon = salon;
    return event;
  },
  replaysSessionSampleRate: lightClient ? 0 : 0.05,
  replaysOnErrorSampleRate: lightClient ? 0 : 0.5,
});

// Crisp.configure('ce09127b-61c6-4f19-b302-2d15a3d87df1', {
//   autoload: true,
// });
const salon = JSON.parse(localStorage.getItem('salons') || '{}');
const statSalone = JSON.parse(localStorage.getItem('statSalone') || '{}');

if (salon[0] !== undefined) {
  // // Crisp.user.setEmail(salon[0].emailVerificata);
  // // Crisp.user.setNickname(salon[0].username);
  // // Crisp.session.setData({
  // //   idsalone: salon[0].idsalone,
  // //   user_id: salon[0].idsalone,
  // //   email_zb: salon[0].email,
  // // });

  // Data di iscrizione
  const dataIscrizione = new Date(salon[0].data_iscrizione);
  // Data odierna
  const oggi = new Date();
  // Calcolo della differenza in millisecondi
  const differenzaInMillisecondi = oggi - dataIscrizione;
  // Convertire la differenza in millisecondi in giorni
  const millisecondiInUnGiorno = 1000 * 60 * 60 * 24; // Millisecondi in un giorno
  const differenzaInGiorni = Math.floor(differenzaInMillisecondi / millisecondiInUnGiorno);
  //quelli saloni nuovi hanno un evento diverso
  if (differenzaInGiorni < 45) {
    // Crisp.session.pushEvent('onboardingUser');
    localStorage.setItem('uf_onboardingUser', 'yes');
  } else {
    localStorage.setItem('uf_onboardingUser', 'no');
  }

  if (statSalone?.allPren > 10) {
    localStorage.setItem('uf_allpren', 'plus_10');
  } else {
    localStorage.setItem('uf_allpren', 'under_10');
  }

  if (!lightClient) {
    (function (w, d, s) {
      if (d.getElementById('usetifulScript')) return;
      var a = d.getElementsByTagName('head')[0];
      var r = d.createElement('script');
      r.async = 1;
      r.src = s;
      r.setAttribute('id', 'usetifulScript');
      r.dataset.token = '2671525f4402acd4b51353d545f209cc';
      a.appendChild(r);
    })(window, document, 'https://www.usetiful.com/dist/usetiful.js');

    LogRocket.identify(salon[0].idsalone, {
      name: salon[0].nome_salone || salon[0].username,
      email: salon[0].emailVerificata || salon[0].email,
      subscriptionType: 'pro',
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ToastContainer
      position='top-right'
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      draggable
      pauseOnHover
      theme='light'
      transition={Slide}
      limit={4}
      icon={false}
      style={{ zIndex: 99999 }}
    />
    <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
  </Provider>,
);

reportWebVitals();
